import React from "react";
import { ButtonH } from "components/UiKit/ButtonH";
import { PopoverH } from "components/UiKit/PopoverH";
import { Ico } from "components/Uikit";
import { ISpace } from "providers/AudioProvider/types";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";

interface ISpaceControlsProps {
  space: ISpace;
}

export const SpaceControls = React.memo(({ space }: ISpaceControlsProps) => {
  const state = useAudioStateContext();
  const handles = useAudioHandlesContext();
  const zoomLevel = 100 - state.zoomLevel;

  const on = !state.voicingSpacesDeleted.some((one) => one === space.nextTrackId);

  const handleDelete = () => {
    if (space.nextTrackId) {
      handles.setVoicingSpacesDeleted((prev) => [...prev, space.nextTrackId!]);
    }
  };

  const handleCut = () => {
    handles.setVoicingSpacesDeleted((prev) => prev.filter((one) => one !== space.nextTrackId));
  };

  return (
    <div
      style={{
        position: "absolute",
        top: `${space.start / zoomLevel}px`,
        height: `${(space.end - space.start) / zoomLevel}px`,
        width: "100%",
        zIndex: 100,
      }}
    >
      {on && (
        <div
          className="_fv _f100 _fcc"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ff001172",
          }}
        >
          <PopoverH
            placement="bottom"
            title={
              <div className="_fv _f100 _fcc">
                {on && <ButtonH onClick={handleDelete}>Delete</ButtonH>}
              </div>
            }
          >
            <Ico>content_cut</Ico>
          </PopoverH>
        </div>
      )}
      {!on && (
        <div
          className="_fv _f100 _fcc"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#00000011",
          }}
        >
          <div
            className="_fv _f100 _fcc _pointer x_voicing_cut0"
            style={{
              width: "100%",
              height: "100%",
            }}
            onClick={handleCut}
          >
            <div className="x_voicing_cut0_icon_cut">
              <Ico>content_cut</Ico>
            </div>
            <div className="x_voicing_cut0_icon_add">
              <Ico>add</Ico>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
